// extracted by mini-css-extract-plugin
module.exports = {"loadingComment":"RiskApplicationApply_loadingComment_4r_ZK"};